import { render, staticRenderFns } from "./IconTriangleSolid.vue?vue&type=template&id=67f5abf2&"
import script from "./IconTriangleSolid.vue?vue&type=script&lang=js&"
export * from "./IconTriangleSolid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports